module.exports = __webpack_public_path__ + "static/media/resourcesMessageButton.c5f20be1.png";